global.bookedby = global.bookedby || {};
global.bookedby.validations = global.bookedby.validations || {};

var usStates = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

global.bookedby.validations.isUsStateByAbbr = function(abbr) {
  return abbr in usStates;
};

global.bookedby.validations.isCorrectlyFormattedPostalCode = function(postalCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(postalCode);
};

/**
 * Validates a phone number
 * @param {string} phoneNumber
 * @returns {*}
 */
global.bookedby.validations.isValidPhoneNumber = function(phoneNumber) {
  if (!phoneNumber) {
    return 'Please enter your phone number';
  } else if (!/^\+1[\d]{10}$/.test(phoneNumber)) {
    return 'Please enter your 10-digit phone number, e.g, (123) 456-7890';
  }
};

module.exports = {};